import AHomeForMaria from '../images/newsletters/AHomeForMaria.png';
import littlethings from '../images/newsletters/littlethings.png';
import MySpecialTreasure from '../images/newsletters/MySpecialTreasure.png';
import TrueReligion from '../images/newsletters/TrueReligion.png';
import news_02102024 from '../images/newsletters/news_02102024.png';
import news_02042024 from '../images/newsletters/news_02042024.png';
import news_01202024 from '../images/newsletters/news_01202024.png';
import news_01102024 from '../images/newsletters/news_01102024.png';
import news_12082023 from '../images/newsletters/news_12082023.png';
import news_11162023 from '../images/newsletters/news_11162023.png';
import news_10092023 from '../images/newsletters/news_10092023.png';
import news_10042023 from '../images/newsletters/news_10042023.png';
import news_09202023 from '../images/newsletters/news_09202023.png';
import news_09022023 from '../images/newsletters/news_09022023.png';
import news_08182023 from '../images/newsletters/news_08182023.png';
import news_08102023 from '../images/newsletters/news_08102023.png';
import news_10282024 from '../images/newsletters/news_10282024.png';
import news_01302025 from '../images/newsletters/news_01302025.png';
import news_04032025 from '../images/newsletters/news_04032025.png';
import news_alex_us from '../images/newsletters/news_alex_us.png';
import news_07212025 from '../images/newsletters/news_07212025.png';
import news_07292025 from '../images/newsletters/news_07292025.png';

export const newsletters = [{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=a619577e42', 
    description: 'The Quilt',
    image: news_07292025,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=4ada713cc4', 
    description: '“…visit the fatherless and widows in their affliction…”',
    image: news_07212025,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=46d487b2c7', 
    description: 'A Big Day For Our Little Family',
    image: news_alex_us,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=d0679da823', 
    description: 'Look After Orphans And Widows',
    image: news_04032025,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=09d2aa4e7d', 
    description: 'Prayer Friends 2025',
    image: news_01302025,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=3c10cdbba9', 
    description: 'Building more than just homes',
    image: news_10282024,
},{
    url: 'https://mailchi.mp/16cee5041ce2/its-been-a-while?e=7a7d0e0a0a', 
    description: 'A Home for Maria',
    image: AHomeForMaria,
}, {
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=db973f85f5', 
    description: 'Little things making big differences',
    image: littlethings,
}, {
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=edfcc23d9e', 
    description: 'Taking advantage of the opportunities given',
    image: MySpecialTreasure,
}, {
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=026f60207b', 
    description: 'True religion is this...',
    image: TrueReligion,
}, {
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=0bed0516cd', 
    description: 'Let God use you, see what happens 🫵',
    image: news_02102024,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=efe8487e09', 
    description: 'You can give them an opportunity',
    image: news_02042024,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=58d5009c9d', 
    description: 'We kept the dress',
    image: news_01202024,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=ab66bf6195', 
    description: "Don't miss out!",
    image: news_01102024,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=374c0992cd', 
    description: 'A Treasure Indeed',
    image: news_12082023,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=c48fa60e67', 
    description: 'Beach Retreat 2023',
    image: news_11162023,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=539eec0c07', 
    description: 'There are still good people in the world',
    image: news_10092023,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=8a1c8686d5', 
    description: 'Today’s The Big Day!!',
    image: news_10042023,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=82d347a90e', 
    description: 'SPANISH CLASSES',
    image: news_09202023,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=bb4881b1f4', 
    description: 'Hey Amigos! Do You Miss Us Yet??',
    image: news_09022023,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=49abacd1c9', 
    description: 'We did a thing...',
    image: news_08182023,
},{
    url: 'https://us18.campaign-archive.com/?u=8e55d62a2f1a18921c9777494&id=a41ae03161', 
    description: 'What is "SALEA"?',
    image: news_08102023,
},
]



export const newsletters_old = [
    {
        id: "1",
        name: "Little things making big differences", 
        date: "2024-04-18", 
        body: "As teams start preparing for coming down to Guatemala", 
    },
    {
        id: "2",
        name: "Taking advantage of the opportunities given", 
        date: "2024-03-04", 
        body: "A Visit to “Mi Especial Tesoro” School", 
    },
];

export const campaigns = {
    "campaigns": [
      {
        "id": "string",
        "web_id": 0,
        "parent_campaign_id": "string",
        "type": "regular",
        "create_time": "2019-08-24T14:15:22Z",
        "archive_url": "string",
        "long_archive_url": "string",
        "status": "save",
        "emails_sent": 0,
        "send_time": "2019-08-24T14:15:22Z",
        "content_type": "template",
        "needs_block_refresh": true,
        "resendable": true,
        "recipients": {
          "list_id": "string",
          "list_is_active": true,
          "list_name": "string",
          "segment_text": "string",
          "recipient_count": 0,
          "segment_opts": {
            "saved_segment_id": 0,
            "prebuilt_segment_id": "subscribers-female",
            "match": "any",
            "conditions": [
              null
            ]
          }
        },
        "settings": {
          "subject_line": "string",
          "preview_text": "string",
          "title": "string",
          "from_name": "string",
          "reply_to": "string",
          "use_conversation": true,
          "to_name": "string",
          "folder_id": "string",
          "authenticate": true,
          "auto_footer": true,
          "inline_css": true,
          "auto_tweet": true,
          "auto_fb_post": [
            "string"
          ],
          "fb_comments": true,
          "timewarp": true,
          "template_id": 0,
          "drag_and_drop": true
        },
        "variate_settings": {
          "winning_combination_id": "string",
          "winning_campaign_id": "string",
          "winner_criteria": "opens",
          "wait_time": 0,
          "test_size": 0,
          "subject_lines": [
            "string"
          ],
          "send_times": [
            "2019-08-24T14:15:22Z"
          ],
          "from_names": [
            "string"
          ],
          "reply_to_addresses": [
            "string"
          ],
          "contents": [
            "string"
          ],
          "combinations": [
            {
              "id": "string",
              "subject_line": 0,
              "send_time": 0,
              "from_name": 0,
              "reply_to": 0,
              "content_description": 0,
              "recipients": 0
            }
          ]
        },
        "tracking": {
          "opens": true,
          "html_clicks": true,
          "text_clicks": true,
          "goal_tracking": true,
          "ecomm360": true,
          "google_analytics": "string",
          "clicktale": "string",
          "salesforce": {
            "campaign": true,
            "notes": true
          },
          "capsule": {
            "notes": true
          }
        },
        "rss_opts": {
          "feed_url": "http://example.com",
          "frequency": "daily",
          "schedule": {
            "hour": 0,
            "daily_send": {
              "sunday": true,
              "monday": true,
              "tuesday": true,
              "wednesday": true,
              "thursday": true,
              "friday": true,
              "saturday": true
            },
            "weekly_send_day": "sunday",
            "monthly_send_date": 0
          },
          "last_sent": "2019-08-24T14:15:22Z",
          "constrain_rss_img": true
        },
        "ab_split_opts": {
          "split_test": "subject",
          "pick_winner": "opens",
          "wait_units": "hours",
          "wait_time": 0,
          "split_size": 1,
          "from_name_a": "string",
          "from_name_b": "string",
          "reply_email_a": "string",
          "reply_email_b": "string",
          "subject_a": "string",
          "subject_b": "string",
          "send_time_a": "2019-08-24T14:15:22Z",
          "send_time_b": "2019-08-24T14:15:22Z",
          "send_time_winner": "string"
        },
        "social_card": {
          "image_url": "string",
          "description": "string",
          "title": "string"
        },
        "report_summary": {
          "opens": 0,
          "unique_opens": 0,
          "open_rate": 0,
          "clicks": 0,
          "subscriber_clicks": 0,
          "click_rate": 0,
          "ecommerce": {
            "total_orders": 0,
            "total_spent": 0,
            "total_revenue": 0
          }
        },
        "delivery_status": {
          "enabled": true,
          "can_cancel": true,
          "status": "delivering",
          "emails_sent": 0,
          "emails_canceled": 0
        },
        "_links": [
          {
            "rel": "string",
            "href": "string",
            "method": "GET",
            "targetSchema": "string",
            "schema": "string"
          }
        ]
      }
    ],
    "total_items": 0,
    "_links": [
      {
        "rel": "string",
        "href": "string",
        "method": "GET",
        "targetSchema": "string",
        "schema": "string"
      }
    ], 
  };

export const content_campaign1 = {
    "variate_contents": [
      {
        "content_label": "Green header",
        "plain_text": "string",
        "html": "<!DOCTYPE html><html xmlns=http://www.w3.org/1999/xhtml><head><meta http-equiv=Content-Type content=\"text/html; charset=UTF-8\"><title>*|MC:SUBJECT|*</title><style type=text/css>body{background-color:#d0e4fe}</style><body leftmargin=0 marginwidth=0 topmargin=0 marginheight=0 offset=0>"
      }
    ],
    "plain_text": "this is a test for the plain text",
    "html": "string",
    "archive_html": "<!DOCTYPE html><html xmlns=http://www.w3.org/1999/xhtml><head><meta http-equiv=Content-Type content=\"text/html; charset=UTF-8\"><title>My Subject</title><style type=text/css>body{background-color:#d0e4fe}</style><body leftmargin=0 marginwidth=0 topmargin=0 marginheight=0 offset=0>",
    "_links": [
      {
        "rel": "string",
        "href": "string",
        "method": "GET",
        "targetSchema": "string",
        "schema": "string"
      }
    ]
  };
  export const content_campaign2 = {
    "variate_contents": [
      {
        "content_label": "Green header",
        "plain_text": "string",
        "html": "<!DOCTYPE html><html xmlns=http://www.w3.org/1999/xhtml><head><meta http-equiv=Content-Type content=\"text/html; charset=UTF-8\"><title>*|MC:SUBJECT|*</title><style type=text/css>body{background-color:#d0e4fe}</style><body leftmargin=0 marginwidth=0 topmargin=0 marginheight=0 offset=0>"
      }
    ],
    "plain_text": "string",
    "html": "string",
    "archive_html": "<!DOCTYPE html><html xmlns=http://www.w3.org/1999/xhtml><head><meta http-equiv=Content-Type content=\"text/html; charset=UTF-8\"><title>My Subject</title><style type=text/css>body{background-color:#d0e4fe}</style><body leftmargin=0 marginwidth=0 topmargin=0 marginheight=0 offset=0>",
    "_links": [
      {
        "rel": "string",
        "href": "string",
        "method": "GET",
        "targetSchema": "string",
        "schema": "string"
      }
    ]
  };

  export const content_campaign = [content_campaign1, content_campaign2];